import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-admin-communications',
    templateUrl: './admin-communications.component.html',
    styleUrls: ['./admin-communications.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminCommunicationsComponent {

}
